'use client';

import * as React from 'react';

import { cn } from '@/lib/utils';

type KeyboardKeyProps = {
  children: string;
} & React.HTMLAttributes<HTMLElement>;

const KeyboardKey = ({
  ref,
  className,
  children,
  ...props
}: KeyboardKeyProps & { ref?: React.RefObject<HTMLElement | null> }) => {
  return (
    <kbd
      ref={ref}
      className={cn(
        'inline-flex h-5 min-w-5 items-center justify-center rounded border border-border bg-muted px-1.5 text-xs font-medium leading-none text-muted-foreground shadow-sm',
        className,
      )}
      {...props}
    >
      {children}
    </kbd>
  );
};

KeyboardKey.displayName = 'KeyboardKey';

export { KeyboardKey };
